import { render } from "./DemoComponentDialog.vue?vue&type=template&id=44db1ef4"
import script from "./DemoComponentDialog.vue?vue&type=script&lang=js"
export * from "./DemoComponentDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__